// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { autocompleteProductsStyles } from "@rpsc/Overrides/Widgets/Header/AutocompleteProducts";
import { color, ellipsis, linkArrowStyle, mergeWithCss } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

autocompleteProductsStyles.headerWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
    `,
};

autocompleteProductsStyles.headerText = {
    variant: "h6",
    css: css`
        margin-bottom: 0;
    `,
};

autocompleteProductsStyles.viewAllLink = {
    ...mergeWithCss(linkArrowStyle, {
        icon: {
            iconProps: {
                size: 11,
                css: css`
                    &,
                    & > svg {
                        height: 13px;
                    }
                    margin-left: 6px;
                `,
            },
        },
        typographyProps: {
            size: 12,
            css: css`
                line-height: 17px;
            `,
        },
    }),
};

autocompleteProductsStyles.container = {
    ...mergeWithCss(autocompleteProductsStyles.container, {
        css: css`
            margin: 0;
        `,
    }),
};

autocompleteProductsStyles.focusedContainer = {
    ...mergeWithCss(autocompleteProductsStyles.focusedContainer, {
        css: css`
            margin: 0;
        `,
    }),
};

autocompleteProductsStyles.productsContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        flex: 1;
        gap: 16px;
    `,
};

autocompleteProductsStyles.imageGridItem = {
    width: 3,
    css: css`
        max-width: 72px;
        height: 72px;
        flex-basis: 72px;
    `,
};

autocompleteProductsStyles.image = {
    css: css`
        width: 72px;
        height: 72px;
        img {
            border: 1px solid ${color("common.border")};
            border-radius: 2px;
        }
    `,
};

autocompleteProductsStyles.infoGridItem = {
    width: 9,
    css: css`
        flex-direction: column;
        max-width: calc(100% - 84px);
        flex-basis: calc(100% - 84px);
        gap: 0;
        &&& {
            margin-left: 12px;
        }
    `,
};

autocompleteProductsStyles.titleLink = {
    color: "common.black",
    typographyProps: {
        variant: "h6",
        forwardAs: "span",
        css: css`
            font-size: 14px;
            width: 100%;
            margin-bottom: 8px;
            ${ellipsis(2)}
        `,
    },
};
